import { getToken, getUser, getRestoLogin } from "../Utils/Common";
import { postAPICall, putAPICall } from "./axiosMethodCalls";

const API_URL =
  getRestoLogin() === "happyhippos"
    ? process.env.REACT_APP_BRIQUE_API
    : process.env.REACT_APP_ETTAS_API;

export const createDiscount = async (data, selected) => {
  try {
    const response = await postAPICall(API_URL + "discounts/create", {
      requester: getUser(),
      token: getToken(),
      name: data.name,
      percentage: data.percentage,
      amount: data.amount,
      use_net_for_discount: data.use_net_for_discount,
      open_discount_amount: data.open_discount_amount,
      item_discount: data.item_discount,
      print_approval_copy: data.print_approval_copy,
      open_discount_rate: data.open_discount_rate,
      ref_no: data.ref_no,
      ref_name: data.ref_name,
      suspend_discount: data.suspend_discount,
      is_vat_exempt: data.is_vat_exempt,
      is_percentage: data.is_percentage,
      menu_ids: selected.map((item) => {
        return item.id;
      }),
    });
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateDiscount = async (data, restoType) => {
  try {
    const params = new URLSearchParams();
    params.append("name", data.name);
    params.append("updated_by", getUser());
    params.append("token", getToken());
    params.append("percentage", data.percentage);
    params.append("amount", data.amount);
    params.append("is_percentage", data.is_percentage);
    params.append("use_net_for_discount", data.use_net_for_discount);
    params.append("open_discount_amount", data.open_discount_amount);
    params.append("item_discount", data.item_discount);
    params.append("print_approval_copy", data.print_approval_copy);
    params.append("open_discount_rate", data.open_discount_rate);
    params.append("ref_no", data.ref_no);
    params.append("ref_name", data.ref_name);
    params.append("suspend_discount", data.suspend_discount);
    params.append("is_vat_exempt", data.is_vat_exempt);

    const response =
      restoType === "happyhippos"
        ? await putAPICall(
            process.env.REACT_APP_BRIQUE_API + "discounts/update/" + data.id,
            params
          )
        : await putAPICall(
            process.env.REACT_APP_ETTAS_API + "discounts/update/" + data.id,
            params
          );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

//GET
export const deleteDiscount = async (id, restoType) => {
  try {
    const params = new URLSearchParams();
    params.append("updated_by", getUser());
    params.append("token", getToken());

    const response =
      restoType === "happyhippos"
        ? await putAPICall(
            process.env.REACT_APP_BRIQUE_API + "discounts/delete/" + id,
            params
          )
        : await putAPICall(
            process.env.REACT_APP_ETTAS_API + "discounts/delete/" + id,
            params
          );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
